<!-- Input Field -->
<div
  id="input-field-container"
  class="input-field-container"
  [ngClass]="customClassInputWrapper"
>
  <!-- Tooltip  -->
  <app-tooltip
    id="input-tooltip-container"
    [disabled]="!showToolTipText"
    [tooltipDelay]="tooltipDelay"
    [tootltipText]="getTooltipText()"
    class="input-tooltip"
  >
    <div id="tooltip-content-container" class="tooltip-content">
      <!-- Input Label -->
      <app-text
        id="tooltip-text"
        textStyleType="overline"
        [ngClass]="{
          error:
            (inputText.invalid && inputText.dirty) ||
            (inputText.invalid && inputText.touched && inputText.value !== '') ||
            (hasCustomError && dyeTitle)
        }"
        >{{ inputLabel | uppercase }}
        <!-- Required Sign -->
        <span
          id="tooltip-required-sign"
          *ngIf="isRequired || requiredIconDisplayed"
          class="red-color"
          >*</span
        >
      </app-text>
      <!-- Tooltip Info Icon -->
      <app-icon
        id="tooltip-info-icon"
        *ngIf="tooltipIcon"
        name="info_outline"
        size="1.5em"
        color="primary"
      ></app-icon>
    </div>
  </app-tooltip>
  <!-- Input Box -->
  <div class="input-box" [ngClass]="customClassInput">
    <!-- Prefix ICON -->
    <app-icon
      id="search-icon"
      *ngIf="prefixIcon"
      name="{{ prefixIcon }}"
      class="search-icon"
      (iconClicked)="onPrefixIconClick()"
      size="1em"
    ></app-icon>
    <!-- Input Element -->
    <input
      [id]="id"
      matInput
      type="{{ inputType }}"
      placeholder="{{ placeholder }}"
      [formControl]="inputText"
      [ngClass]="getInputClass()"
      [ngStyle]="customStyle"
      (change)="onChangeInput($event)"
      (input)="onChangeInputValueEmitter($event)"
      (paste)="onPaste($event)"
      (keyup.enter)="onKeyEnter($event)"
      (keypress)="onKeyPress($event)"
      (keydown)="onKeyDown($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    <!-- Cancel Icon Right -->
    <app-icon
      *ngIf="inputText.value && !hasCustomWarning && !hasCustomError && !isDisabled"
      name="cancel"
      class="cancel-icon"
      id="cancel-icon"
      color="grey"
      size="1.5em"
      (iconClicked)="onCancel()"
    ></app-icon>
    <!-- Error ICon Right -->
    <app-icon
      *ngIf="getDisplayStatus()"
      name="error"
      class="cancel-icon red-color"
      id="cancel-icon"
      size="1.5em"
      (iconClicked)="onCancel()"
    ></app-icon>
    <!-- Warn ICon Right -->
    <app-icon
      *ngIf="hasCustomWarning"
      name="warning"
      class="cancel-icon yellow-color"
      id="cancel-icon"
      size="1.5em"
      (iconClicked)="onCancel()"
    ></app-icon>
  </div>
  <div class="helper-text" *ngIf="helperText!== ''" >
    <app-text [textStyleType]="'caption'">Helper Text</app-text>
  </div>
</div>
<!-- helper text -->

<!-- Error Lists -->
<ng-container *ngIf="!inputModelConfig?.errConfig?.['required']?.hide">
  <mat-error
    id="required-error"
    *ngIf="inputText.hasError('required') && inputText.touched"
  >
    <app-text id="required-error-caption" class="red-color" [textStyleType]="'caption'">{{
      requiredErrorMessage | translate
    }}</app-text>
  </mat-error>
</ng-container>

<mat-error id="max-len-error" *ngIf="inputText.hasError('maxlength')">
  <app-text id="max-len-error-caption" [textStyleType]="'caption'" class="red-color"
    >{{ 'input.maxlength' | translate }} {{ maxLength }}.
  </app-text>
</mat-error>

<ng-container *ngIf="!inputModelConfig?.errConfig?.['max']?.hide">
  <mat-error id="min-length-error" *ngIf="inputText.hasError('min')">
    <app-text id="min-length-error-caption" [textStyleType]="'caption'" class="red-color"
      >{{ 'input.min' | translate }} {{ minValue }}.</app-text
    >
  </mat-error>
</ng-container>

<ng-container *ngIf="!inputModelConfig?.errConfig?.['max']?.hide">
  <mat-error id="max-length-error" *ngIf="inputText.hasError('max')">
    <app-text id="max-length-error-caption" [textStyleType]="'caption'" class="red-color"
      >{{ 'input.max' | translate }} {{ maxValue }}.</app-text
    >
  </mat-error>
</ng-container>

<mat-error
  id="pattern-error"
  *ngIf="inputText.hasError('pattern') && shouldShowInvalidFormatError()"
>
  <app-text id="pattern-error-caption" [textStyleType]="'caption'" class="red-color">{{
    'input.invalidFormat' | translate
  }}</app-text>
</mat-error>

<mat-error id="email-error" *ngIf="inputText.hasError('email')">
  <app-text id="email-error-caption" [textStyleType]="'caption'" class="red-color">{{
    'input.invalidEmail' | translate
  }}</app-text>
</mat-error>

<mat-error id="input-custom-error" *ngIf="hasCustomError">
  <app-text
    id="input-text-custom-error"
    [textStyleType]="customErrorMsgTextType"
    class="red-color"
    >{{ customErrorMsg }}</app-text
  >
</mat-error>

<mat-error id="warning-error" *ngIf="hasCustomWarning">
  <app-text id="warning-input-text" [textStyleType]="'caption'" class="yellow-color">{{
    customWarningMsg
  }}</app-text>
</mat-error>

<ng-container *ngFor="let key of inputModelConfig?.errKey">
  <mat-error
    id="{{ inputModelConfig.errConfig[key].id }}-error"
    *ngIf="inputText.hasError(key) && inputModelConfig.errConfig[key].hide"
  >
    <app-text
      id="{{ inputModelConfig.errConfig[key].id }}-error-caption"
      [textStyleType]="'caption'"
      class="red-color"
      >{{
        inputModelConfig.errConfig[key].msg
          | translate: inputModelConfig.errConfig[key].params
      }}</app-text
    >
  </mat-error>
</ng-container>

<!-- TODO: More error messages can be added as per need -->
